import { atom, injectStore } from "@zedux/react";
import { FilterTypes, IContext, IFilter } from "@src/types";

export const NO_FILTER = {
    type: FilterTypes.NO_FILTER,
    query: null
} as IFilter

export const selectedFilterAtom = atom("selected_filter", (context: IContext, activeTopicId: number) => {
    return injectStore<IFilter>(NO_FILTER)
})

